import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    courseSectionData: [],
    courseEntireData: [],
    completedLectures: [],
    totalNoOfLectures: 0,
    activeSectionId: '',
    activeSubSectionId: '',
    viewCourseLoading: false,
    reviewModal: false,
    isSidebarOpen: false,
}

const viewCourseSlice = createSlice({
    name: 'viewCourse',
    initialState,
    reducers: {
        setCourseSectionData: (state, action) => {
            state.courseSectionData = action.payload;
        },
        setEntireCourseData: (state, action) => {
            state.courseEntireData = action.payload;
        },
        setTotalNoOfLectures: (state, action) => {
            state.totalNoOfLectures = action.payload;
        },
        updateCompletedLectures: (state, action) => {
            state.completedLectures = action.payload;
        },
        setActiveSectionId: (state, action) => {
            state.activeSectionId = action.payload;
        },
        setActiveSubSectionId: (state, action) => {
            state.activeSubSectionId = action.payload;
        },
        setViewCourseLoading: (state, action) => {
            state.viewCourseLoading = action.payload;
        },
        setReviewModal: (state, action) => {
            state.reviewModal = action.payload;
        },
        resetViewCourseSlice: (state) => {
            state.activeSectionId = '';
            state.activeSubSectionId = '';
            state.completedLectures = [];
            state.viewCourseLoading = false;
            state.totalNoOfLectures = 0;
            state.setEntireCourseData = [];
            state.courseSectionData = [];
        },
        setSidebarOpen: (state, action) => {
            state.isSidebarOpen = action.payload;
        },
    }
});

export const {
    setCourseSectionData,
    setEntireCourseData,
    setTotalNoOfLectures,
    updateCompletedLectures,
    setActiveSectionId,
    setActiveSubSectionId,
    setViewCourseLoading,
    setReviewModal,
    setSidebarOpen,
} = viewCourseSlice.actions;

export default viewCourseSlice.reducer;